import type { CSSProperties, ReactNode } from 'react';

export function PageTitle({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="page-title">
      <div className="display" style={{ fontSize: 22 }}>
        {title.toUpperCase()}
      </div>
      {action}
    </div>
  );
}

export function Loading({ label = 'LOADING…' }: { label?: string }) {
  return (
    <div
      style={{
        padding: 20,
        color: 'var(--ink-dim)',
        fontFamily: 'var(--f-display)',
        letterSpacing: '0.16em',
        fontSize: 12,
      }}
    >
      {label}
    </div>
  );
}

export function ErrorBox({ text }: { text: string }) {
  return (
    <div
      style={{
        padding: 12,
        borderRadius: 8,
        background: 'rgba(230,57,70,0.16)',
        border: '1px solid rgba(230,57,70,0.45)',
        color: 'var(--c-red)',
        fontSize: 13,
      }}
    >
      {text}
    </div>
  );
}

export function Card({
  title,
  value,
  accent,
}: {
  title: string;
  value: string;
  accent?: string;
}) {
  return (
    <div
      className="card"
      style={{ padding: 14 }}
    >
      <div className="tag" style={{ marginBottom: 6 }}>{title}</div>
      <div
        className="display"
        style={{
          fontSize: 24,
          color: accent ?? 'var(--ink)',
          textShadow: accent ? `0 0 12px ${accent}` : 'none',
        }}
      >
        {value}
      </div>
    </div>
  );
}

export function Field({
  label,
  children,
  hint,
}: {
  label: string;
  children: ReactNode;
  hint?: string;
}) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span className="tag" style={{ fontSize: 9 }}>{label}</span>
      {children}
      {hint && (
        <span style={{ fontSize: 11, color: 'var(--ink-dim)' }}>{hint}</span>
      )}
    </label>
  );
}

export function Modal({
  title,
  onClose,
  children,
  footer,
  maxWidth,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: number | string;
}) {
  return (
    <div
      className="modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal" style={maxWidth ? { maxWidth } : undefined}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 14,
          }}
        >
          <span className="display" style={{ fontSize: 16 }}>{title}</span>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--ink-muted)',
              fontSize: 20,
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>{children}</div>
        {footer && (
          <div style={{ marginTop: 16, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

export const fullW: CSSProperties = { width: '100%' };
